import { useContext, useEffect, useState } from "react";
import { MyContext } from "../MyContext/MyProvider";
import { Dropdown, Menu, Typography, Space, Select } from "antd";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";

import CSV from "../dashboard/dashboardMain/CSV/CSV";
import Removeselectionbutton from "../shared/removeselectionbutton";
import { Icon } from "@iconify/react";
import Listingnavbar from "../components/listingnavbar";
import { useNavigate } from "react-router-dom";
import Pattern from "../dashboard/Pattern/pattern";
import { toast } from "react-toastify";
import { isLoggedIn, notify } from "../utils/utils";

const Findings = () => {
  const navigate = useNavigate();
  const {
    processedFiles,
    selectedFiles,
    setSelectedFiles,
    setSelectedEntitites,
    reductionType,
    setReductionType,
    setFindingsWithHighlight,
    setAllowList,
    searchText,
    setSearchText,
    setSaveTerms,
    savePara, // Make sure this is imported from the context
    setSavePara, // Also, this should be defined in the context
  } = useContext(MyContext);
  const [selectedText, setSelectedText] = useState(""); // Local state to hold selected text

  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [options, setOptions] = useState([
    { value: "highlight", label: "Highlight" },
    { value: "replace", label: "Replace" },
    { value: "mask", label: "Mask" },
  ]);

  useEffect(() => {
    console.log(isLoggedIn());

    if (!isLoggedIn()) {
      // navigate("/login");
      notify("Session expired", "error");
      window.location.href = "/login";
    }
  }, []);

  useEffect(() => {
    setSelectedFiles(processedFiles);
  }, [processedFiles, setSelectedFiles]);

  useEffect(() => {
    const newFindings = processedFiles.reduce(
      (acc, file) => [...acc, ...file.findings],
      []
    );
    setFindingsWithHighlight(newFindings);
  }, [processedFiles, setFindingsWithHighlight]);

  useEffect(() => {
    if (selectedFiles && selectedFiles.length > 0) {
      const entities = selectedFiles.flatMap((file) =>
        file.findings.map((finding) => finding.entity_type)
      );
      const uniqueEntities = Array.from(new Set(entities));
      setAllowList(uniqueEntities);
    } else {
      setSelectedEntitites([]);
    }
  }, [selectedFiles, processedFiles, setAllowList, setSelectedEntitites]);

  const handleReductionTypeChange = (value) => {
    setReductionType(value);

    // Update options based on the selected reduction type
    if (value === "replace") {
      setOptions([
        { value: "highlight", label: "Highlight" },
        { value: "replace", label: "Replace" },
      ]);
    } else {
      setOptions([
        { value: "highlight", label: "Highlight" },
        { value: "replace", label: "Replace" },
        { value: "mask", label: "Mask" },
      ]);
    }
  };

  const handleFileChange = (fileIds) => {
    const selectedFiles = processedFiles.filter((file) =>
      fileIds.includes(file.file_id)
    );
    setSelectedFiles(selectedFiles);
  };

  const handleSelect = (value) => {
    console.log(value);
    if (value && !selectedTags.includes(value) && value.length >= 2) {
      setSelectedTags([...selectedTags, value]);
      if (!searchText.includes(value)) {
        setSearchText([...searchText, value]);
      }
    }
  };

  const handleDeselect = (value) => {
    console.log(value);
    // Remove the value from selectedTags
    setSelectedTags((prev) => prev.filter((val) => val !== value));

    // Remove the value from searchText
    setSearchText((prev) => prev.filter((val) => val !== value));

    // Remove the value from saveTerms
    setSaveTerms((prevSaveTerms) => {
      // Create a shallow copy of the previous saveTerms object
      const updatedSaveTerms = { ...prevSaveTerms };

      // Delete the key corresponding to the value
      delete updatedSaveTerms[value];

      // Return the updated object
      return updatedSaveTerms;
    });

    console.log(searchText);
  };

  const handleMenuClick = (info) => {
    const currentSelection = [...selectedKeys];
    const selectedIndex = currentSelection.indexOf(info.key);

    if (selectedIndex > -1) {
      currentSelection.splice(selectedIndex, 1);
    } else {
      currentSelection.push(info.key);
    }

    setSelectedKeys(currentSelection);
    handleFileChange(currentSelection);
  };

  const menu = (
    <Menu selectedKeys={selectedKeys} onClick={handleMenuClick} multiple>
      {processedFiles.map((doc) => (
        <Menu.Item key={doc.file_id}>{doc.file_name}</Menu.Item>
      ))}
    </Menu>
  );
  useEffect(() => {
    const handleMouseUp = () => {
      let text = "";
      if (window.getSelection) {
        text = window.getSelection().toString();
      } else if (document.getSelection) {
        text = document.getSelection().toString();
      } else if (document.selection) {
        text = document.selection.createRange().text;
      }
      setSelectedText(text);
    };

    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  const handleSearchSelectedText = () => {
    if (selectedText.trim()) {
      if (selectedText.length >= 5) {
        setSavePara([...savePara, selectedText.trim()]); // Save selected text to savePara
        if (!searchText.includes(selectedText.trim())) {
          setSearchText([...searchText, selectedText.trim()]); // Also add to searchText
        }
        toast.success("Sucessfully Selected a Text");
      } else {
        toast.error("Please select at least 5 alphabetic characters.");
      }
    } else {
      toast.error("No text is selected");
    }
  };
  return (
    <>
      <Listingnavbar />
      {processedFiles.length ? (
        <div className="libraries-mian-container">
          <div className="v-center main-top gap-3">
            <div
              className="back-btn v-center h-center gap-2 cursor-pointer"
              onClick={() => {
                navigate("/dashboard/fileupload");
              }}
            >
              <Icon
                icon="ion:chevron-back-outline"
                width={20}
                height={18}
                color="#FFFFFF"
              />
              <label className="large fw-medium text-white roboto-family ">
                Back
              </label>
            </div>

            <div className="dash-search v-center space-between gap-2 m-auto">
              <span style={{ fontSize: "28px", color: "#314185" }}>+</span>
              <Select
                mode="tags"
                style={{ width: "100%" }}
                placeholder="Add search text"
                value={selectedTags}
                // options={searchText.map((option) => ({
                //   value: option,
                //   label: option,
                // }))}
                notFoundContent={null}
                onSelect={handleSelect}
                onDeselect={handleDeselect}
                onInputKeyDown={(e) => {
                  if (e.key === "Enter" && e.target.value) {
                    const value = e.target.value.trim();

                    // Check if the value has a minimum of 2 alphabetic characters
                    if (value.length >= 2 && /^[a-zA-Z]+$/.test(value)) {
                      if (!searchText.includes(value)) {
                        setSearchText([...searchText, value]);
                      }
                    } else {
                      // Show a toast notification if the input is invalid
                      toast.error(
                        "Please enter at least 2 alphabetic characters."
                      );
                    }
                  }
                }}
                allowClear
                disabled={reductionType === "replace"}
              />
            </div>
          </div>

          <div className="libraries-top-container w-100 d-flex flex-column gap-4">
            <div className="keywords-div h-center v-center gap-3 w-100">
              <div className="pattern-top-con v-center h-center ">
                {reductionType !== "replace" && (
                  <Removeselectionbutton reductionType={reductionType} />
                )}
                <div  className="">
               
                    <button className="large keyword-selected fw-medium text-white v-center h-center cursor-pointer d-flex gap-2 px-3" onClick={handleSearchSelectedText}>Select Text</button>
                    {/* <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder="Add search text"
                      value={searchText} // Display search text in the Select input
                      onInputKeyDown={(e) => {
                        if (e.key === "Enter" && e.target.value) {
                          const value = e.target.value.trim();
                          if (value.length >= 2 && /^[a-zA-Z]+$/.test(value)) {
                            setSearchText([...searchText, value]);
                          } else {
                            toast.error(
                              "Please enter at least 2 alphabetic characters."
                            );
                          }
                        }
                      }}
                      allowClear
                    /> */}
                </div>
                {reductionType !== "replace" && (
                  <Dropdown overlay={menu} trigger={["click"]}>
                    <Typography.Link>
                      <Space>
                        Uploaded Docs
                        <DownOutlined />
                      </Space>
                    </Typography.Link>
                  </Dropdown>
                )}
                <Space wrap>
                  <Select
                    defaultValue="Select Reduction Type"
                    style={{ width: 241 }}
                    onChange={handleReductionTypeChange}
                    options={options} // Use the state-managed options here
                  />
                </Space>
              </div>
            </div>
            {selectedFiles.length > 0 && <CSV />}
          </div>

          {selectedFiles.map((file, index) => {
            return (
              <Pattern
                key={index}
                id={index}
                selectedFile={file}
                reductionType={reductionType}
              />
            );
          })}
        </div>
      ) : (
        <div className="v-center w-100 space-between px-5 not-selected-files-div">
          <div
            className="back-btn v-center h-center gap-2 cursor-pointer"
            onClick={() => {
              navigate("/dashboard/fileupload");
            }}
          >
            <Icon
              icon="ion:chevron-back-outline"
              width={20}
              height={18}
              color="#FFFFFF"
            />
            <label className="large fw-medium text-white roboto-family cursor-pointer">
              Back
            </label>
          </div>
          <h3 className="text-center text-secondary">No files are selected</h3>
          <div></div>
        </div>
      )}
    </>
  );
};

export default Findings;
